import { render } from "./FintriviaSteps.vue?vue&type=template&id=e06eca0e&scoped=true"
import script from "./FintriviaSteps.vue?vue&type=script&lang=js"
export * from "./FintriviaSteps.vue?vue&type=script&lang=js"

import "./FintriviaSteps.vue?vue&type=style&index=0&id=e06eca0e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e06eca0e"]])

export default __exports__